import { memo, useMemo } from "react";

import type { QueryData } from "../../../model";

type Props = {
	// ディスカウント
	discount?: QueryData["aliveItemsPerReservation"]["discount"];
};

export const DiscountOfVoucherAndDiscountCompositions = memo(({ discount }: Props) => {
	/**
	 * ディスカウント金額
	 */
	const discountPriceText = useMemo(() => {
		const discountPrice = discount?.discountPrice;
		if (discountPrice === undefined) return "¥ 0";

		return `− ¥ ${discountPrice.toLocaleString()}`;
	}, [discount?.discountPrice]);
	/**
	 * ディスカウント金額ラベル
	 */
	const discountPriceLabel = useMemo(() => {
		const discountName = discount?.name;
		if (discountName === undefined) return "ディスカウントは使用されていません";

		return discountName;
	}, [discount?.name]);

	return (
		<div className="space-y-4">
			<p className="font-medium">{discountPriceLabel}</p>
			<p className="text-right">{discountPriceText}</p>
		</div>
	);
});
